import type { Dispatch as ReduxDispatch } from '@reduxjs/toolkit';
import type { BaseAction } from '../@types/actions';

export const REQ_PERSIST_CREDIT_APPLICATION_DATA = 'REQ/PERSIST_CREDIT_APPLICATION_DATA';
export type REQ_PERSIST_CREDIT_APPLICATION_DATA_TYPE = BaseAction<
  typeof REQ_PERSIST_CREDIT_APPLICATION_DATA
> & {
  ssn?: string;
  email?: string;
  estimatedMileage?: string | number;
  telephone?: string;
};

export type CREDIT_APPLICATION_ACTION = REQ_PERSIST_CREDIT_APPLICATION_DATA_TYPE;

type Dispatch = ReduxDispatch<CREDIT_APPLICATION_ACTION>;

export const save =
  (ssn?: string, email?: string, estimatedMileage?: string | number, telephone?: string) =>
  (dispatch: Dispatch) =>
    dispatch({
      type: REQ_PERSIST_CREDIT_APPLICATION_DATA,
      ssn,
      email,
      estimatedMileage,
      telephone,
    });
